angular.module("digiexam.services.faults", []);
